
/**
 * 수료증 유형
 */
export type EnrollmentInfoCertificatesItemCertificateType = typeof EnrollmentInfoCertificatesItemCertificateType[keyof typeof EnrollmentInfoCertificatesItemCertificateType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentInfoCertificatesItemCertificateType = {
  COMPLETION: 'COMPLETION',
  PARTICIPATION: 'PARTICIPATION',
  ACHIEVEMENT: 'ACHIEVEMENT',
} as const;
